import FilterOption from "../../../components/FilterOption";
import FilterText from "../../../components/FilterText";
import FilterDate from "../../../components/FilterDate";
import BaseButton from "../../../components/BaseButton";
import React from "react";
import { frontEnvelopeFolderStatusToBack } from "../../../utils/utils";

export const FilterGroup = (props) => {

    const { filters, setFilters, onFilter, filterLoading } = props

    function handleKeyDown(event) {
        if (event.key === "Enter")
            onFilter()
    }

    return (
        <div className="filter-container">
            <FilterText
                id={"subject"}
                labelValue={"Nome da Pasta"}
                filters={filters}
                setFilters={setFilters}
                placeholder={"Nome da Pasta"}
                handleEnter={handleKeyDown}
            />
            <FilterText
                id={"external_id"}
                labelValue={"ID da Pasta"}
                filters={filters}
                setFilters={setFilters}
                placeholder={"ID da Pasta"}
                handleEnter={handleKeyDown}
            />
            <FilterText
                id={"document_number"}
                labelValue={"Documento do assinante"}
                filters={filters}
                setFilters={setFilters}
                placeholder={"Documento do assinante"}
                handleEnter={handleKeyDown}
            />
            <FilterOption
                id={"status"}
                labelValue={"Status da Pasta"}
                frontEnvelopeStatus={frontEnvelopeFolderStatusToBack}
                filters={filters}
                setFilters={setFilters}
            />
            <FilterDate
                id={"initial_date"}
                labelValue={"Data inicial"}
                filters={filters}
                setFilters={setFilters}
                handleEnter={handleKeyDown}
            />
            <FilterDate
                id={"final_date"}
                labelValue={"Data final"}
                filters={filters}
                setFilters={setFilters}
                handleEnter={handleKeyDown}
            />
            <BaseButton
                label="Filtrar"
                onClick={() => onFilter()}
                className="filter__btn btn btn--animated btn--white"
                loading={filterLoading}
                isDisabled={false}
            />
        </div>
    );
}
